import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { supabase } from "../utils/supabaseClient";
import "../styles/Navbar.css";

function Navbar() {
  const location = useLocation();
  const [click, setClick] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isProductsOpen, setIsProductsOpen] = useState(false);

  const handleClick = () => {
    setClick((prev) => {
      const next = !prev;
      if (!next) {
        setIsProductsOpen(false);
      }
      return next;
    });
  };
  const closeMobileMenu = () => {
    setClick(false);
    setIsProductsOpen(false);
  };

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        // Fetch partners with their products to check if they have any products
        const { data, error } = await supabase
          .from("partners")
          .select(
            `
            id, 
            name, 
            url, 
            icon_url,
            products (id)
          `
          )
          .order("name");

        if (error) {
          throw error;
        }

        setPartners(data);
      } catch (err) {
        console.error("Error fetching partners:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 10);
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 960) {
        setIsProductsOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleProductsDropdown = (event) => {
    if (window.innerWidth > 960) {
      return;
    }

    event.preventDefault();
    setIsProductsOpen((prev) => !prev);
  };

  // Check if we're on the login page or any auth-related pages
  const isAuthPage =
    location.pathname === "/login" ||
    location.pathname === "/register" ||
    location.pathname === "/forgot-password";

  if (isAuthPage) return null;

  return (
    <nav className={`navbar ${visible ? "" : "navbar-hidden"}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
          <img
            src="/logo/new-logo.png"
            alt="Infinipoint Technologies"
            className="navbar-logo-img"
          />
        </Link>

        <div className="menu-icon" onClick={handleClick}>
          {click ? <X size={24} /> : <Menu size={24} />}
        </div>

        <ul className={click ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item">
            <Link to="/" className="nav-links" onClick={closeMobileMenu}>
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-links" onClick={closeMobileMenu}>
              About Us
            </Link>
          </li>
          <li className={`nav-item dropdown ${isProductsOpen ? "active" : ""}`}>
            <div
              className="products-link"
              onClick={toggleProductsDropdown}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  toggleProductsDropdown(event);
                }
              }}
            >
              <span className="nav-links">Products</span>
              <ChevronDown
                size={20}
                className={`dropdown-arrow ${isProductsOpen ? "open" : ""}`}
              />
            </div>
            <ul className="dropdown-menu">
              {loading ? (
                <li className="dropdown-item loading">Loading...</li>
              ) : (
                partners.map((partner) => {
                  // Check if partner has products
                  const hasProducts =
                    partner.products && partner.products.length > 0;

                  return (
                    <li key={partner.name} className="dropdown-item">
                      {hasProducts ? (
                        <Link
                          to={`/products/${partner.id}`}
                          className="dropdown-link"
                          onClick={closeMobileMenu}
                        >
                          {partner.name}
                        </Link>
                      ) : (
                        <div className="dropdown-link coming-soon">
                          {partner.name}
                        </div>
                      )}
                    </li>
                  );
                })
              )}
            </ul>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-links" onClick={closeMobileMenu}>
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
